import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MobileMenuService } from '../../../../shared/services/mobile-menu.service';
import { mobileMenu } from '../../../../../data/mobile-menu';
import { MobileMenuItem } from '../../../../shared/interfaces/mobile-menu-item';
import { User } from '../../../../shared/interfaces/user';
import { Router } from '@angular/router';
import { CurrencyService } from '../../../../shared/services/currency.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { StoreService } from '@app/shared/services/store.service';
import { environment as env } from '@environments/environment';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnDestroy, OnInit, AfterViewInit {
    private destroy$: Subject<any> = new Subject();

    isOpen = false;
    @Input() links: MobileMenuItem[] = mobileMenu;
    // extend
    currentUser: User;

    languages = [
        // { name: 'فارسی Farsi', image: 'language-1', dir: 'rtl', symbol: 'FA' },
        // { name: 'English', image: 'language-2', dir: 'ltr', symbol: 'EN' },
    ];

    currencies = [
        // { name: 'IRR ریال', url: '', code: 'IRR', symbol: 'ریال' },
        // { name: '$ US Dollar', url: '', code: 'USD', symbol: '$' }
    ];

    isMultiLanguage = env.multicurrency;
    isMultiCurrency = env.multicurrency;
    constructor(
        public store: StoreService,
        public mobilemenu: MobileMenuService,
        private router: Router,
        public currencyService: CurrencyService,
        private auth: AuthenticationService) {

        if (this.auth.isLoggedIn()) {
            this.currentUser = this.auth.currentUserValue;
            // alert(this.currentUser.FirstName);
            // to-do : prepare links for guest or loged
        }
        try {
            if (localStorage.getItem('store')) {
                const storeData = JSON.parse(localStorage.getItem('store'));
                // this.theme.languages = store.languages;
                // this.theme.currencies = store.currencies;
                this.languages = storeData.languages;
                this.currencies = storeData.currencies;
                console.log(this.languages);
                // add to links

                // prepair langugaes links
                const currencyLink = this.links.find(x => x.label === 'Currency');
                this.currencies.forEach((key: any, val: any) => {
                    currencyLink.children.push(
                        {
                            type: 'button', label: key.name,
                            data:
                            {
                                name: key.name,
                                currency: key.symbol,
                                symbol: key.symbol
                            }
                        }
                    );
                });

                // prepair langugaes links
                const langugaeLink = this.links.find(x => x.label === 'Language');
                this.languages.forEach((key: any, val: any) => {
                    langugaeLink.children.push(
                        {
                            type: 'button', label: key.name,
                            data:
                            {
                                dir: key.dir,
                                symbol: key.symbol
                            }
                        }
                    );
                });
            }
        } catch { }
    }

    ngAfterViewInit(): void {

    }

    ngOnInit(): void {
        this.mobilemenu.isOpen$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => this.isOpen = isOpen);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onItemClick(event: MobileMenuItem): void {

        if (event.type === 'link') {
            this.mobilemenu.close();
        }
        console.log(event.data);
        if (event.data && event.data.language) {
            console.log(event.data); // change language
            this.changeLanguage(event.data);
        }
        if (event.data && event.data.currency) {
            console.log(event.data); // change language
            this.setCurrency(event.data);
        }

    }

    changeLanguage(e) {
        localStorage.setItem('dir', e.dir);
        localStorage.setItem('lan', e.symbol.toUpperCase());
        document.location.reload();
    }

    setCurrency(currency): void {
        this.currencyService.options = {
            code: currency.code,
            display: currency.symbol,
        };
    }

    logout() {
        this.auth.logout();
        this.router.navigate(['/account/login']);
    }
}
